import { supabase } from '@/lib/supabase-client'
import { queryClient } from '@/lib/react-query'

const IMPERSONATION_KEY = 'impersonation:email'

export const getImpersonatedEmail = () => {
  return localStorage.getItem(IMPERSONATION_KEY)
}

export const clearImpersonationMarker = () => {
  localStorage.removeItem(IMPERSONATION_KEY)
}

const setImpersonationMarker = (email: string) => {
  localStorage.setItem(IMPERSONATION_KEY, email)
}

type ImpersonateResponse = {
  access_token: string
  refresh_token: string
  expires_at: number
}

export const impersonateByEmail = async (email: string) => {
  const { data, error } = await supabase.functions.invoke<ImpersonateResponse>('dev-impersonate', {
    body: { email },
  })

  if (error || !data) {
    throw error ?? new Error('No session returned')
  }

  // Clear any cached data from the previous user before switching sessions
  queryClient.clear()

  const { access_token, refresh_token } = data
  const { error: sessionError } = await supabase.auth.setSession({
    access_token,
    refresh_token,
  })

  if (sessionError) {
    throw sessionError
  }

  setImpersonationMarker(email)

  return data
}
